let tl = gsap.timeline();
let mm = gsap.matchMedia();

tl.from(".header__row--top img.header-logo__image",{
    y:30,
    opacity:0,
    delay:1,
    duration:0.5,
    ease: "power2.out"
})
tl.from("nav.menu-list li.menu-list__list-item",{
y:30,
opacity:0,
stagger:0.3,
duration:1.2
})

gsap.from("div#shopify-section-template--26682611335481__custom_liquid_hUwPxW h5",{
    y:30,
    opacity:0,
    delay:1,
    duration:0.5,
    ease: "power2.out",
    scrollTrigger:"div#shopify-section-template--26682611335481__custom_liquid_hUwPxW h5"
})
gsap.from("div#shopify-section-template--26682611335481__custom_liquid_hUwPxW h2",{
    y:30,
    opacity:0,
    delay:1,
    duration:0.5,
    ease: "power2.out",
    scrollTrigger:"div#shopify-section-template--26682611335481__custom_liquid_hUwPxW h2"
})


// animation for desktop 

mm.add("(min-width:750px)",()=>{
// occasion circles
gsap.from("div#shopify-section-template--26682611335481__section_zgiU7w .group-block-content",{
    y:30,
    opacity:0,
    duration:0.5,
    stagger:0.5,
    ease: "power2.out",
    scrollTrigger:"div#shopify-section-template--26682611335481__section_zgiU7w .group-block-content"
})
// end occasion circles

// card occasion circles
gsap.from("div#occasionProductsTrack .occasion-product-card",{
    y:30,
    opacity:0,
    duration:0.5,
    stagger:0.5,
    ease: "power2.out",
    scrollTrigger:{
        trigger:"div#occasionProductsTrack .occasion-product-card",
        start:"top 80%",
        toggleActions:"play none none none"
    }
})

// end cardoccasion circles

})

// animation for mobile

mm.add("(max-width:749px)",()=>{
    // occasion circles
    gsap.utils.toArray("div#shopify-section-template--26682611335481__section_zgiU7w .group-block-content").forEach((el) => {
  gsap.from(el, {
     y:30,
    opacity:0,
    duration:0.5,
    ease: "power2.out",
    scrollTrigger:{
        trigger:el,
        start:"top 80%",
        toggleActions:"play none none none",
    }
  });
});
// end occasion circles
// card occasion circles
gsap.utils.toArray("div#occasionProductsTrack .occasion-product-card").forEach(el =>{
    gsap.from(el, {
     y:30,
    opacity:0,
    duration:0.5,
    ease: "power2.out",
    scrollTrigger:{
        trigger:el,
        start:"top 80%",
        toggleActions:"play none none none",
    }
  });
})
// end card occasion circles

// matchmedia end
})